export const paymentMethod = {
  credit_card: 'Cartāo de crédito',
  credit_card_subscription: 'Assinatura Cartāo de crédito',
  boleto_parcelado: 'Boleto',
  boleto_subscription: 'Assinatura Boleto',
  pix: 'Pix',
};
